import React from "react";
import './Input.css';

//import 'bootstrap/dist/css/bootstrap.min.css';
//import { Dropdown, Form, Button,Container,Col } from "react-bootstrap";

const Input =({message, setMessage, sendMessage})=>(
    <div className="container-chat">
       <div className="row">
           <div style={{display:"inline-block"}}>
              <input className= "input" type="text" placeholder="Type a message..."
                     value={message}
                     onChange={(event) =>setMessage(event.target.value)}
                     onKeyPress={(event)=>event.key === 'Enter'?sendMessage(event) : null}
              />
           </div>
           <div style={{display:"inline-block"}}>
              <button
                className="surveyButton blue"
                onClick={(event)=>sendMessage(event)}>Send
              </button>
           </div>
       </div>
        <label style={{visibility:"hidden"}}></label>
    </div>
)

export default Input;
